const ar = {
  tasks: {
    priority: {
      critical: '🔴 حرج',
      urgent: '🟠 عاجل',
      high: '🟡 عالي',
      medium: '🟢 متوسط',
      low: '🔵 منخفض',
      label: {
        critical: 'حرج',
        urgent: 'عاجل',
        high: 'عالي',
        medium: 'متوسط',
        low: 'منخفض'
      }
    },
    status: {
      pending: 'قيد الانتظار',
      assigned: 'تم التعيين',
      inProgress: 'قيد التنفيذ',
      completed: 'مكتمل',
      cancelled: 'ملغي',
      cancelAction: 'إلغاء المهمة'
    },
    editModal: {
      title: 'تعديل المهمة',
      property: 'العقار',
      bookingRef: 'رقم الحجز',
      taskTitle: 'عنوان المهمة',
      taskTitleRequired: 'عنوان المهمة *',
      taskTitlePlaceholder: 'مثال: تنظيف شامل للعقار',
      scheduledDate: 'التاريخ المجدول',
      scheduledDateRequired: 'التاريخ المجدول *',
      scheduledTime: 'الوقت المجدول',
      scheduledTimeHint: 'اختياري - صيغة 24 ساعة',
      priority: 'الأولوية',
      priorityRequired: 'الأولوية *',
      status: 'الحالة',
      statusRequired: 'الحالة *',
      assignedTo: 'المكلف',
      unassigned: 'غير مكلف',
      notes: 'ملاحظات',
      notesPlaceholder: 'ملاحظات أو تعليمات للفريق...',
      notesHint: '',
      guestMessage: 'رسالة للضيف / العميل',
      guestMessagePlaceholder: 'مثال: سوف نزور الضيف الساعة ٢ م',
      guestMessageHint: 'هذه الرسالة سوف تظهر للضيف / العميل عند السؤال عن حالة الطلب',
      cancel: 'إلغاء',
      save: 'حفظ التغييرات',
      saving: 'جاري الحفظ...',
      errorSaving: 'فشل تحديث المهمة. يرجى المحاولة مرة أخرى.',
      fieldTeamReport: 'تقرير الفريق الميداني'
    },
    guestRequestBadge: 'طلب ضيف',
    type: {
      cleaning: 'نظافة',
      maintenance: 'صيانة',
      housekeeping: 'تدبير منزلي',
      restock: 'مستلزمات ضيافة',
      guest_service: 'خدمة ضيوف',
      early_checkin_request: 'طلب دخول مبكر',
      late_checkout_request: 'طلب مغادرة متأخرة'
    },
    table: {
      headers: {
        task: 'المهمة',
        property: 'العقار',
        bookingRef: 'رقم الحجز',
        priority: 'الأولوية',
        status: 'الحالة',
        scheduledDate: 'التاريخ المجدول',
        assignedTo: 'المكلف',
        actions: 'الإجراءات'
      },
      tooltip: {
        critical: 'حرجة: مغادرة ودخول في نفس اليوم',
        urgent: 'عاجلة: مغادرة اليوم',
        high: 'عالية: مغادرة قريبة',
        medium: 'متوسطة: حجز عادي',
        low: 'منخفضة: حجز بعيد'
      },
      bulk: {
        tasksSelected: 'مهمة محددة',
        assignTo: 'تعيين إلى',
        markComplete: 'تحديد كمكتمل',
        cancelSelection: 'إلغاء التحديد'
      },
      dropdown: {
        changeStatus: 'تغيير الحالة'
      },
      overdue: 'متأخر',
      unassigned: 'غير مكلف',
      ticketRef: 'رقم الطلب',
      editTooltip: 'تعديل',
      completeTooltip: 'تحديد كمكتمل'
    },
    listView: {
      filters: {
        today: 'اليوم',
        week: 'هذا الأسبوع',
        month: 'هذا الشهر',
        allStatuses: 'كل الحالات'
      },
      createButton: '+ إنشاء مهمة جديدة يدوياً',
      loading: 'جاري تحميل المهام...',
      retry: 'إعادة المحاولة',
      errorLoading: 'فشل تحميل المهام. يرجى المحاولة مرة أخرى.',
      emptyTitle: 'لا توجد مهام',
      emptyTextProperty: 'لا توجد مهام مجدولة لهذا العقار مع الفلاتر المحددة.',
      emptyText: 'لا توجد مهام للنطاق الزمني والحالة المحددة.',
      sections: {
        critical: 'حرج - يتطلب إجراء فوري',
        urgent: 'عاجل - أولوية اليوم',
        high: 'أولوية عالية - خلال 24-48 ساعة القادمة',
        medium: 'أولوية متوسطة - هذا الأسبوع',
        low: 'أولوية منخفضة - مستقبلاً',
        completed: 'مكتملة'
      }
    },
    // The guest-checkout record, shown on every task surface
    // (tasks/manual-guest-checkout-event.md Part 2, D43).
    //
    // ⚠️ Its OWN namespace, not inside `card` — the same four strings render on the ops table, the
    // ops card, the ops edit modal and the crew card, and one shared vocabulary is what stops the
    // four drifting apart. `card.checkout` already exists and means something else entirely: the
    // SCHEDULED departure. This is the record of when the guest actually left.
    //
    // 🔴 D23 — it informs, it never instructs. Never «ابدأ التنظيف».
    // 🔴 D21 — the wording follows the evidence: a human confirmation is a stronger claim than a
    //          keypad, which proves a door opened and not that anyone left.
    guestCheckout: {
      recorded: 'غادر الضيف',
      possible: 'مغادرة محتملة',
      // الضيف ضغط الزر بنفسه على اللوحة عند الباب — خبر، وليس تأكيداً من الفريق (D19/D62).
      guestReported: 'أبلغ الضيف بمغادرته',
      sourceManual: 'تأكيد الفريق',
      sourceGuest: 'لوحة الباب',
      sourceDevice: 'القفل الذكي',
      recordedBy: 'سجّله'
    },
    // A supervisor corrects a clean's record (tasks/cleaning-performance-report.md D7). The original
    // is never lost — «عُدّل بواسطة …» names who changed it and why.
    cleanRecord: {
      title: 'سجل النظافة',
      startLabel: 'البدء',
      noStart: 'لم يُسجَّل بدء',
      teamLabel: 'الفريق',
      noTeam: 'لا أحد مسجَّل',
      correctButton: 'تصحيح',
      startInput: 'وقت البدء الفعلي',
      startHint: 'بتوقيت الرياض.',
      teamInput: 'من شارك في النظافة',
      reasonInput: 'سبب التصحيح',
      reasonPlaceholder: 'مثال: نسي الضغط على زر البدء',
      save: 'حفظ التصحيح',
      cancel: 'إلغاء',
      saved: 'تم حفظ التصحيح',
      failed: 'تعذّر حفظ التصحيح — حاول مرة أخرى',
      loadFailed: 'تعذّر تحميل سجل النظافة',
      correctedBy: 'عُدّل بواسطة',
      autoFilled: 'سُجّل الفريق تلقائياً من ضغطة «بدء التنظيف».',
      changedStart: 'وقت البدء',
      changedTeam: 'الفريق',
      invalidReason: 'اكتب سبب التصحيح.',
      invalidChange: 'لم يتغيّر شيء لحفظه.',
      invalidStatus: 'لا يمكن تصحيح مهمة نظافة لم تبدأ أو أُلغيت.',
      invalidStartedAt: 'وقت البدء غير صالح — يجب أن يسبق الانتهاء وبفارق معقول.',
      invalidCleaners: 'قائمة الفريق غير صالحة.'
    },
    card: {
      overdue: 'متأخر',
      ticketRef: 'رقم الطلب',
      bookingRef: 'رقم الحجز',
      checkout: 'المغادرة',
      checkin: 'الوصول',
      checkinUnset: 'غير محدد',
      guest: 'الضيف',
      turnoverAlert: 'وقت التجهيز',
      turnoverHours: 'ساعات فقط!',
      turnoverUrgent: 'جدول ضيق للغاية - يتطلب إجراءً فورياً',
      statusLabel: 'الحالة',
      assignedToLabel: 'مكلف إلى',
      unassigned: 'غير مكلف',
      guestMessage: 'رسالة للضيف',
      internalNotes: 'ملاحظات',
      completedAt: 'اكتملت في',
      completedBy: 'بواسطة',
      editButton: 'تعديل',
      startButton: 'بدء العمل',
      startButtonCleaning: 'بدء التنظيف',
      undoStart: 'تراجع',
      // Who took part in a clean (tasks/cleaning-performance-report.md D3/D4/D6)
      joinButton: 'انضممت',
      cleanersLabel: 'الفريق',
      joinCrewFull: 'فريق مهمة النظافة هذه مكتمل — لا يمكن إضافة شخص آخر.',
      joinNotOpen: 'يمكن الانضمام أثناء النظافة فقط.',
      undoStartForbidden: 'التراجع عن بدء النظافة من صلاحية المشرف — تواصل معه لتصحيحه.',
      startedAt: 'بدأت',
      took: 'استغرقت',
      minutes: 'دقيقة',
      // Cleaning target timer (tasks/cleaning-timer.md D8) — «تجاوز الوقت» (founder, 23 Sep; was «فوق الهدف»), never «متأخر».
      timerLeftOf: 'متبقٍ من',
      timerOver: 'تجاوز الوقت',
      completeButton: 'تحديد كمكتمل',
      address: 'العنوان',
      errorStatus: 'فشل تحديث الحالة. يرجى المحاولة مرة أخرى.',
      errorAssign: 'فشل تعيين المهمة. يرجى المحاولة مرة أخرى.',
      fieldTeamReport: 'تقرير الفريق الميداني',
      completionNotes: 'ملاحظات الإنجاز',
      completionNotesPlaceholder: 'أضف ملاحظات عن حالة العقار أو أي ملاحظات أخرى...',
      completionRating: 'تقييم حالة العقار',
      stars: 'نجوم',
      hideDetails: 'إخفاء',
      showDetails: 'تفاصيل',
      completeFailed: 'تعذّر إنهاء المهمة. يرجى المحاولة مرة أخرى.',
      completeBlockedMessage: 'يجب الإجابة على جميع بنود قائمة الفحص والمستلزمات قبل إنهاء المهمة',
      completeBlockedRemainingLabel: 'المتبقي',
      completeBlockedChecklist: 'قائمة الفحص',
      completeBlockedSupplies: 'المستلزمات'
    },
    photos: {
      upload: 'رفع صورة',
      uploading: 'جاري الرفع...',
      before: 'قبل',
      after: 'بعد',
      issue: 'مشكلة',
      completion: 'إتمام',
      maxReached: 'تم الوصول للحد الأقصى (10 صور)',
      deleteConfirm: 'حذف هذه الصورة؟',
      uploadFailed: 'فشل رفع الصورة',
      tooLarge: 'حجم الصورة كبير جداً (الحد الأقصى 10 ميغابايت)',
      invalidType: 'نوع الملف غير مدعوم (JPEG, PNG, WebP فقط)',
      photoCount: 'صور',
      selectType: 'نوع الصورة',
      evidenceTitle: 'الصور المرفقة'
    },
    checklist: {
      openButton: 'قائمة الفحص',
      suppliesButton: 'المستلزمات',
      title: 'قائمة الفحص',
      suppliesTitle: 'تقرير المستلزمات',
      done: 'تم',
      notDone: 'لم يتم',
      na: 'لا ينطبق',
      available: 'متوفر',
      needsRestock: 'يحتاج تعبئة',
      addComment: 'إضافة ملاحظة',
      reasonPrompt: 'ما السبب؟',
      commentPlaceholder: 'ملاحظة قصيرة (اختياري)',
      saveFailed: 'تعذّر الحفظ. يرجى المحاولة مرة أخرى.',
      close: 'إغلاق',
      allAnswered: 'تمت الإجابة على جميع البنود',
      remainingHint: 'أجب على كل بند قبل إنهاء المهمة',
      unanswered: 'لم يُجب',
      resultsTitle: 'نتائج قائمة الفحص',
      suppliesResultsTitle: 'تقرير المستلزمات',
      restockTitle: 'مستلزمات بحاجة إلى تعبئة',
      restockEmpty: 'لا توجد مستلزمات مطلوبة',
      // What a supplies item actually contains — a hint under the label, not answerable rows.
      // Keys are CleaningTemplate itemIds (immutable). Gate: config/suppliesLabels.js
      supplyContents: {
        personal_care_amenities: '(طقم أسنان · سليبر · مناشف · شامبو · صابون · مناديل ورقية · كلاسيك مناديل)',
        guest_display_screen: 'إن كان التلفاز على مدخل آخر، أعده إلى مدخل شاشة الترحيب ثم سجّل السبب.'
      }
    },
    reportIssue: {
      button: 'الإبلاغ عن مشكلة',
      title: 'الإبلاغ عن مشكلة',
      category: 'نوع المشكلة',
      categoryPlaceholder: 'اختر النوع',
      electrical: 'كهرباء',
      plumbing: 'سباكة',
      furniture: 'أثاث',
      appliances: 'أجهزة',
      other: 'أخرى',
      description: 'وصف المشكلة',
      descriptionPlaceholder: 'صف المشكلة التي وجدتها...',
      addPhoto: 'إضافة صورة',
      changePhoto: 'تغيير الصورة',
      submit: 'إرسال البلاغ',
      submitting: 'جاري الإرسال...',
      cancel: 'إلغاء',
      success: 'تم إنشاء بلاغ الصيانة',
      failed: 'تعذّر إرسال البلاغ. يرجى المحاولة مرة أخرى.',
      categoryRequired: 'اختر نوع المشكلة',
      descriptionRequired: 'اكتب وصفاً للمشكلة'
    },
    // "Would you host this guest again?" — asked when a turnover clean is closed
    // (tasks/post-checkout-review-and-replies.md L5–L7). A bare choice: no colours, no warnings (D4).
    // `reasons` keys are the backend's codes (guestAssessmentService.REASON_CODES) — keep them in step.
    guestAssessment: {
      question: 'هل نستضيف هذا الضيف مرة أخرى؟',
      yes: 'نعم',
      no: 'لا',
      reasonPrompt: 'ما السبب؟',
      reasons: {
        damage: 'تلف أو كسر',
        smoking: 'تدخين',
        extra_guests: 'عدد ضيوف أكثر من المسموح',
        rules_broken: 'مخالفة قواعد السكن',
        very_dirty: 'الشقة متسخة جداً',
        other: 'أخرى'
      },
      notePlaceholder: 'ملاحظة قصيرة (اختياري)',
      noteRequiredPlaceholder: 'اكتب ما حدث',
      photoLabel: 'صورة المشكلة',
      addPhoto: 'أضف صورة للمشكلة',
      photoAttached: 'أُرفقت صورة المشكلة',
      errorRequired: 'أجب على سؤال استضافة الضيف قبل إنهاء المهمة',
      errorAnswer: 'اختر نعم أو لا',
      errorReason: 'اختر سبباً',
      errorNote: 'اكتب ملاحظة توضح السبب',
      errorPhoto: 'أضف صورة واحدة على الأقل للمشكلة',
      errorPhotoLocked: 'لا يمكن حذف هذه الصورة لأنها دليل إجابة «لا»',
      modalTitle: 'إنهاء التنظيف',
      cancel: 'إلغاء',
      summaryLabel: 'نستضيفه مرة أخرى؟',
      bulkSkipped: 'لم تُغلق لأنها تحتاج إجابة سؤال الضيف:'
    },
    maintenance: {
      pageTitle: 'مهامي',
      tasksRemaining: 'مهمة متبقية',
      allDone: 'تم إنجاز كل المهام!',
      filterAll: 'كل المهام',
      filterMyTasks: 'المكلفة لي',
      emptyText: 'لا توجد مهام مجدولة لهذه الفترة.',
      searchPlaceholder: 'بحث برقم المهمة أو العنوان...'
    },
    page: {
      headerTitle: 'إدارة المهام',
      loading: 'جاري تحميل المهام...',
      loadError: 'فشل تحميل المهام. يرجى المحاولة مرة أخرى.',
      totalTasks: 'إجمالي',
      taskUnit: 'مهمة',
      critical: 'حرجة',
      overdue: 'متأخرة',
      newTask: 'مهمة جديدة',
      exportBtn: 'تصدير',
      searchPlaceholder: 'بحث في المهام...',
      dateAll: 'الكل',
      dateToday: 'اليوم',
      dateWeek: 'هذا الأسبوع',
      dateMonth: 'هذا الشهر',
      statusActive: 'النشطة',
      statusAll: 'كل الحالات',
      statusPending: 'قيد الانتظار',
      statusAssigned: 'تم التعيين',
      statusInProgress: 'قيد التنفيذ',
      statusCompleted: 'مكتملة',
      priorityAll: 'كل الأولويات',
      propertyAll: 'كل العقارات',
      bookingAll: 'كل الحجوزات',
      bookingWith: 'مع حجز',
      bookingWithout: 'بدون حجز',
      assigneeMine: 'المسندة لي',
      assigneeAll: 'كل المهام',
      assigneeUnassigned: 'غير مسندة',
      sourceAll: 'كل المصادر',
      sourcePms: 'مهام الإدارة',
      sourceService: 'مهام النظافة',
      sourceGuest: 'طلبات الضيوف',
      typeAll: 'كل الأنواع',
      viewCards: 'بطاقات',
      viewList: 'قائمة',
      groupByPriority: 'تجميع حسب الأولوية',
      groupByProperty: 'تجميع حسب العقار',
      groupByStatus: 'تجميع حسب الحالة',
      groupByDate: 'تجميع حسب التاريخ',
      emptyTitle: 'لا توجد مهام',
      emptyText: 'لم يتم العثور على مهام تطابق معايير البحث',
      emptyCreateBtn: 'إنشاء مهمة جديدة',
      supervisorTeam: 'مهام الفريق',
      supervisorMine: 'مهامي',
      emptyMineTitle: 'لا توجد مهام مكلفة لك',
      emptyMineText: 'لم يتم تعيين أي مهام لك حالياً',
      propertyUnknown: 'غير محدد',
      unassigned: 'غير مكلف',
      csvTask: 'المهمة',
      csvProperty: 'العقار',
      csvPriority: 'الأولوية',
      csvStatus: 'الحالة',
      csvDate: 'التاريخ المجدول',
      csvAssignee: 'المكلف',
      groupCritical: '🔴 حرجة',
      groupUrgent: '🟠 عاجلة',
      groupHigh: '🟡 عالية',
      groupMedium: '🟢 متوسطة',
      groupLow: '🔵 منخفضة',
      groupPending: 'قيد الانتظار',
      groupAssigned: 'تم التعيين',
      groupInProgress: 'قيد التنفيذ',
      groupCompleted: 'مكتملة'
    },
    create: {
      title: 'إنشاء مهمة جديدة',
      typeLabel: 'نوع المهمة *',
      propertyLabel: 'العقار *',
      propertyLoading: 'جاري تحميل العقارات...',
      propertySelect: 'اختر العقار',
      propertyError: 'فشل تحميل العقارات',
      propertyRequired: 'يرجى اختيار العقار',
      taskTitleLabel: 'عنوان المهمة *',
      taskTitlePlaceholder: 'مثال: تنظيف شامل للشقة',
      maintenanceTitlePlaceholder: 'مثال: إصلاح تسريب المكيف',
      taskTitleRequired: 'يرجى إدخال عنوان المهمة',
      suppliesLabel: 'المستلزمات المطلوبة *',
      suppliesHint: 'إن كانت للوحدة مهمة مستلزمات مفتوحة، ستُضاف إليها — ويمكن تقديم موعدها أو رفع أولويتها فقط.',
      suppliesRequired: 'يرجى اختيار مستلزم واحد على الأقل',
      mergedSuccess: '✅ أُضيفت إلى مهمة المستلزمات',
      dateLabel: 'التاريخ المجدول *',
      dateRequired: 'يرجى اختيار التاريخ المجدول',
      dateHint: 'لا يمكن اختيار تاريخ في الماضي',
      timeLabel: 'الوقت المجدول',
      priorityLabel: 'الأولوية',
      assignLabel: 'تعيين إلى',
      assignEmpty: 'غير مكلف',
      assignHint: 'اتركه فارغاً إذا لم يتم التعيين بعد',
      notesLabel: 'ملاحظات',
      notesPlaceholder: 'أي تفاصيل أو تعليمات إضافية...',
      submitBtn: 'إنشاء المهمة',
      submitting: 'جاري الإنشاء...',
      cancelBtn: 'إلغاء',
      success: '✅ تم إنشاء المهمة بنجاح!',
      error: 'فشل إنشاء المهمة. يرجى المحاولة مرة أخرى.',
      // The part the server refused (TASK_006 + details.field) — utils/taskErrorCodes.js
      invalidType: 'نوع المهمة غير صالح',
      invalidProperty: 'العقار غير صالح أو غير موجود',
      invalidTitle: 'يرجى إدخال عنوان المهمة',
      invalidScheduledDate: 'التاريخ المجدول غير صالح أو في الماضي',
      invalidPriority: 'الأولوية غير صالحة',
      invalidCleaningMode: 'نوع التنظيف غير صالح',
      invalidAssignedTo: 'المكلف غير صالح',
      invalidRestockItems: 'يرجى اختيار مستلزم واحد على الأقل من القائمة',
      invalidNotes: 'الملاحظات أطول من المسموح'
    },
    stats: {
      critical: 'حرجة',
      pending: 'قيد الانتظار',
      inProgress: 'قيد التنفيذ',
      completed: 'مكتملة'
    },
    // «تقارير الأداء» — per-cleaner figures (tasks/cleaning-performance-report.md step 5). Western
    // digits, the supervisor tabs' rule. ⚠️ «15» and «3 ساعات» must match CLEAN_MIN_MINUTES / CLEAN_MAX_MINUTES (be/services/supervisorWorklist.js).
    performance: {
      tab: 'تقارير الأداء',
      intro: 'أداء فريق النظافة لكل شخص — مهام النظافة بين الضيوف المكتملة في الفترة.',
      openFromTile: 'افتح تقارير الأداء — التفاصيل لكل عامل',
      periods: { last7: 'آخر 7 أيام', thisMonth: 'هذا الشهر', lastMonth: 'الشهر الماضي', custom: 'فترة محددة' },
      from: 'من', to: 'إلى', apply: 'عرض',
      error: 'تعذّر تحميل تقارير الأداء.',
      empty: 'لا توجد مهام نظافة مكتملة في هذه الفترة.',
      // «أوقات تسجيل المغادرة» (tasks/checkout-times-card.md) — RECORDED times, never "when guests left".
      checkoutTimes: {
        title: 'أوقات تسجيل المغادرة',
        intro: 'متى سُجّلت مغادرة الضيف في المغادرات التي نُظّفت خلال الفترة.',
        windows: { before08: 'قبل 8 ص', '08to10': '8 – 10 ص', '10to12': '10 ص – 12 م', '12to14': '12 – 2 م', '14to16': '2 – 4 م', from16: 'بعد 4 م' },
        recorded: 'مسجّلة', missing: 'بلا وقت مسجّل',
        byGuest: 'سجّلها الضيف (بطاقة الباب)', byOps: 'سجّلتها العمليات',
        empty: 'لا توجد مغادرات مسجّلة في هذه الفترة.',
        about: 'عن هذه الأوقات',
        note: 'الأوقات هي وقت تسجيل المغادرة في النظام. ما تُدخله العمليات قد يكون وقت اكتشاف خروج الضيف وليس وقت مغادرته الفعلي. النسب من المغادرات المسجّلة فقط.'
      },
      // The strip (step 8): the answer before the table — team within-target share, average vs target, volume.
      cleansInPeriod: 'مهام النظافة',
      strip: { within: 'ضمن الهدف', noMeasured: 'لا مهام بهدف', average: 'متوسط الوقت', of: 'من' },
      cols: {
        cleaner: 'العامل', cleans: 'مهام النظافة', soloPaired: 'بمفرده / مع زميل', average: 'متوسط الوقت',
        timing: 'مقابل الهدف', within: 'ضمن الهدف', over: 'تجاوز الوقت', notMeasured: 'بلا قياس'
      },
      noAttributed: 'لا توجد مهام منسوبة لأحد في هذه الفترة.',
      unattributedLine: 'غير منسوبة لأحد — لم يُسجَّل من قام بها (حساب مشترك أو قبل التحديث).',
      show: 'عرض', hide: 'إخفاء',
      about: 'كيف تُحسب الأرقام',
      with: 'مع',
      corrected: 'مُعدَّلة',
      timing: { noTarget: 'بلا هدف', missingStart: 'لم تبدأ', tooShort: 'أقل من 15 دقيقة', tooLong: 'أكثر من 3 ساعات' },
      footnote: 'مهمة الفريق تُحسب لكل شخص فيها بوقتها كاملاً. «ضمن الهدف» = أُنهيت في وقتها المستهدف أو قبله. «بلا قياس» = لم تبدأ، أو أقل من 15 دقيقة، أو أكثر من 3 ساعات (أُنهيت متأخراً) — لا تدخل في المتوسط ولا في النسبة؛ وما كان بلا هدف يدخل في المتوسط فقط.'
    },
    attention: {
      tabWorklist: 'قائمة المهام',
      tabAttention: 'المتابعة',
      intro: 'ما الذي يحتاج متابعة الآن — حسب الأقرب أثراً على الضيف.',
      loading: 'جاري التحميل...',
      error: 'تعذّر تحميل قائمة المتابعة.',
      retry: 'إعادة المحاولة',
      emptyTitle: 'لا شيء يحتاج متابعة الآن',
      emptyHint: 'كل عمل اليوم إمّا اكتمل أو ما زال في وقته.',
      counts: {
        dueToday: 'موعدها اليوم',
        overdue: 'متأخرة',
        openRefills: 'مستلزمات ضيافة مفتوحة',
        needsOwner: 'مهام غير مسندة'
      },
      needsOwnerGoal: 'صيانة ومستلزمات · الهدف: 0',
      guestArriving: 'ضيف يصل',
      runningFor: 'يعمل عليها منذ',
      targetOf: 'الهدف',
      overTarget: 'تجاوز الوقت',
      dueAt: 'موعدها',
      noDeadline: 'بلا موعد',
      unassigned: 'بلا مسؤول',
      // «حالة التشغيل» rows (tasks/unit-operational-status.md §9 item 3) — a unit that needs a decision.
      unitStatus: 'حالة الوحدة',
      openUnit: 'فتح الوحدة',
      reviewDueAt: 'موعد المراجعة',
      unitReason: {
        UNIT_STOPPED_REVIEW_DUE: 'موقوفة وتجاوزت موعد المراجعة — استأنفها أو مدّد الإيقاف',
        NO_TURNOVER_CLEAN: 'غير معروفة — غادر الضيف ولا توجد مهمة تنظيف مسجلة',
        ARRIVAL_TIME_UNKNOWN: 'غير معروفة — تعذّر تحديد موعد وصول الضيف',
        DEPARTURE_TIME_UNKNOWN: 'غير معروفة — تعذّر تحديد موعد مغادرة الضيف',
        LOOKUP_FAILED: 'غير معروفة — تعذّر التحقق من حالة الوحدة'
      },
      fromCleaning: 'من التنظيف',
      addedByPerson: 'أضافها أحد الفريق',
      lateMinutes: 'دقيقة تأخيراً',
      lateHours: 'ساعة تأخيراً',
      lateDays: 'يوم تأخيراً',
      chase: 'تمت المتابعة',
      chasing: 'جاري التسجيل...',
      chasedOnce: 'متابعة واحدة',
      chasedTimes: 'متابعات',
      chaseFailed: 'تعذّر تسجيل المتابعة.',
      openFailed: 'تعذّر فتح المهمة.',
      notActionable: 'المهمة مغلقة — لا شيء لمتابعته.',
      showAll: 'عرض الكل في قائمة المهام',
      moreItems: 'عنصراً إضافياً غير معروض',
      cleanTime: {
        title: 'متوسط زمن التنظيف',
        window: 'آخر ٧ أيام',
        unit: 'دقيقة',
        sample: 'تنظيفة محتسبة',
        empty: 'لا توجد تنظيفات مكتملة بوقت مسجّل في هذه المدة.'
      },
      state: {
        TASK_OVERDUE: 'متأخرة',
        TASK_DUE_TODAY: 'موعدها اليوم',
        TASK_ON_TIME: 'في وقتها',
        TASK_NO_DEADLINE: 'بلا موعد'
      }
    }
  },
  arrivalReadiness: {
    heading: 'جاهزية تسجيل الدخول اليوم',
    subtitle: 'هل سيدخل ضيوف اليوم، وهل وصلتهم التعليمات؟',
    loading: 'جاري التحميل...',
    error: 'تعذّر تحميل فحص الجاهزية — اعتبروا جاهزية اليوم غير مؤكدة.',
    retry: 'إعادة المحاولة',
    empty: 'لا يوجد تسجيل دخول اليوم أو غداً.',
    headline: {
      ready: 'كل تسجيل الدخول اليوم جاهز',
      readySub: 'رمز القفل مؤكد وصالح عند موعد الوصول، ورسالة تسجيل الدخول في مسارها، والتنظيف في مساره.',
      action: 'تسجيل دخول يحتاج تدخّلاً',
      actionSub: 'هذه الحجوزات تحتاج معالجة قبل وصول الضيف — رمز القفل أو رسالة تسجيل الدخول أو التنظيف.',
      unverified: 'فحص غير مكتمل',
      unverifiedSub: 'تعذّر التحقق من بعض حالات تسجيل الدخول — اعتبروا جاهزيتها غير مؤكدة.'
    },
    status: {
      ready: 'جاهز',
      action: 'يحتاج تدخّلاً',
      unverified: 'تعذّر التحقق',
      pending: 'قيد الانتظار',
      na: 'لا ينطبق'
    },
    chip: { action: 'يحتاج تدخّلاً', unverified: 'تعذّر التحقق', ready: 'جاهز', noLock: 'بدون قفل' },
    day: {
      today: 'تسجيل الدخول اليوم',
      todayHint: 'رمز القفل يجب أن يعمل عند الوصول',
      tomorrow: 'تسجيل الدخول غداً',
      tomorrowHint: 'رسالة تسجيل الدخول تُرسل اليوم'
    },
    column: { guest: 'الضيف', property: 'العقار', time: 'وقت الدخول', lockCode: 'رمز القفل', message: 'رسالة تسجيل الدخول', cleaning: 'نظافة الوحدة', status: 'الحالة' },
    // The ops stop — fourth signal (tasks/unit-operational-status.md D17). Shown only when stopped.
    unitStopped: 'الوحدة موقوفة — انقل الضيف أو استأنف الوحدة قبل وصوله',
    unitStopUnverified: 'تعذّر التحقق من إيقاف الوحدة',
    stopReason: { maintenance: 'صيانة / عطل', deep_cleaning: 'تنظيف عميق', owner_use: 'استخدام المالك', inspection: 'فحص', other: 'أخرى' },
    // Keyed on the backend's machine reason code, never on its Arabic text (I18N_STRATEGY: the code is the contract). Mirror of be/services/cleaningReadiness/engine.js REASON — see web/src/utils/cleaningReasonCodes.js.
    cleaningReason: {
      CLEANING_DONE: 'اكتمل التنظيف',
      CLEANING_ON_TRACK: 'التنظيف لم يبدأ بعد — الوقت متاح',
      CLEANING_DUE_SOON: 'التنظيف لم يبدأ ووقت الوصول قريب',
      CLEANING_IN_PROGRESS: 'التنظيف جارٍ ولم يكتمل بعد',
      CLEANING_OVERDUE: 'تنظيف سابق لم يكتمل',
      CLEANING_WINDOW_NEGATIVE: 'الوحدة مشغولة حتى بعد موعد وصول الضيف — لا وقت للتنظيف',
      CLEANING_WINDOW_TIGHT: 'لا يوجد وقت كافٍ للتنظيف بين المغادرة والوصول',
      CLEANING_WINDOW_UNKNOWN: 'تعذّر تحديد موعد مغادرة الضيف السابق',
      CLEANING_NO_TASK: 'لا توجد مهمة تنظيف مسجّلة لهذه الوحدة',
      CLEANING_UNKNOWN_ARRIVAL: 'تعذّر تحديد موعد الوصول',
      CLEANING_ASSESS_FAILED: 'تعذّر تقييم حالة التنظيف'
    },
    // The guest is demonstrably inside — evidence from the lock, never an inference.
    // Only the positive case has a label: "no entry recorded" is NOT a claim that the
    // guest has not arrived (he may be at the door on a code that failed), so it is
    // deliberately given no wording at all rather than a reassuring one.
    entry: { arrived: 'دخل الضيف' },
    // تأكيد الفريق لدخول ضيف لم يرصده القفل (دخل برمز داخلي/طوارئ) — tasks/manual-guest-arrival-confirm.md.
    // ⚠️ صياغة مختلفة عمداً عن «دخل الضيف» أعلاه، ولون رمادي لا أخضر: إنسان أكّد، والقفل لم يرصد شيئاً.
    // نفس الصياغة مكرّرة في صفحة الحجز (عربية فقط) — أي تعديل هنا يُطبَّق هناك أيضاً.
    confirmArrival: {
      action: 'تأكيد الدخول',
      confirmed: 'أكّد الفريق الدخول',
      by: 'سجّله',
      undo: 'تراجع',
      timeLabel: 'وقت دخول الضيف',
      timeHint: 'بتوقيت الرياض — عدّل الساعة إن كان الضيف قد دخل قبل الآن.',
      save: 'حفظ',
      cancel: 'إلغاء',
      failed: 'تعذّر الحفظ — حاول مرة أخرى',
      notApplicable: 'الحجز ملغي — لا يوجد ضيف ليدخل',
      timeInvalid: 'وقت الدخول غير صالح — لا يمكن أن يكون في المستقبل أو خارج فترة الإقامة'
    },
    // Labels for the timestamp under the cleaning verdict. Only two verdicts carry one.
    cleaningStamp: { completed: 'اكتمل', started: 'بدأ' },
    noLockSuffix: 'بدون قفل ذكي — لا ينطبق عليه هذا الفحص.',
    lockStateAsOf: 'حالة الأقفال كما في',
    lockStateSource: '(من بيانات النظام، دون اتصال مباشر بالقفل).',
    messageDegraded: 'تعذّر تقييم حالة الرسائل — حالة رمز القفل غير متأثرة.',
    cleaningDegraded: 'تعذّر تقييم حالة التنظيف — بقية الفحوصات غير متأثرة.',
    manualSend: {
      action: 'تأكيد الإرسال اليدوي',
      done: 'أُرسلت رسالة تسجيل الدخول يدوياً',
      by: 'بواسطة',
      undo: 'تراجع',
      failed: 'تعذّر الحفظ — حاول مرة أخرى',
      notApplicable: 'هذا الحجز تُرسل رسالته تلقائياً — تم تحديث الصف'
    }
  },
  // Ops vocabulary is «تسجيل الخروج», never «مغادرات» — it pairs with «تسجيل الدخول» above so the
  // dashboard reads as one instrument. The GUEST message keeps «موعد المغادرة»: different audience,
  // already-approved wording (tasks/checkout-message-automation.md §0).
  departureReadiness: {
    heading: 'جاهزية تسجيل الخروج اليوم',
    subtitle: 'هل استلم الضيوف رسائل تذكير موعد المغادرة اليوم؟',
    loading: 'جاري التحميل...',
    error: 'تعذّر تحميل فحص الجاهزية — اعتبروا جاهزية اليوم غير مؤكدة.',
    retry: 'إعادة المحاولة',
    empty: 'لا يوجد تسجيل خروج اليوم.',
    headline: {
      ready: 'كل تسجيل الخروج اليوم في مساره',
      readySub: 'تذكير موعد الخروج أُرسل أو في طريقه لكل ضيف يغادر اليوم.',
      action: 'تسجيل خروج يحتاج تدخّلاً',
      actionSub: 'هذه الحجوزات تحتاج إرسالاً يدوياً أو مراجعة — ضيوفها لم يستلموا التذكير.',
      unverified: 'فحص غير مكتمل',
      unverifiedSub: 'تعذّر تقييم حالة التذكير لبعض الحجوزات — اعتبروها غير مؤكدة.'
    },
    status: {
      ready: 'جاهز',
      action: 'يحتاج تدخّلاً',
      unverified: 'تعذّر التحقق',
      pending: 'قيد الانتظار',
      na: 'لا ينطبق'
    },
    chip: { action: 'يحتاج تدخّلاً', unverified: 'تعذّر التحقق', pending: 'قيد الانتظار', ready: 'جاهز', na: 'لا ينطبق' },
    automationOff: 'أتمتة تذكير تسجيل الخروج معطّلة على مستوى النظام — لن يُرسل أي تذكير تلقائياً اليوم.',
    column: { guest: 'الضيف', property: 'العقار', time: 'وقت الخروج', reminder: 'التذكير', checkout: 'تسجيل الخروج', status: 'الحالة' },
    // States the window rule plainly, so a red row nobody can fix is understood rather than chased.
    windowNote: 'يُرسل التذكير آلياً قبل موعد الخروج بساعة.',
    manualSend: {
      action: 'تأكيد الإرسال اليدوي',
      done: 'أُرسلت رسالة تذكير موعد المغادرة يدوياً',
      by: 'بواسطة',
      undo: 'تراجع',
      failed: 'تعذّر الحفظ — حاول مرة أخرى',
      notApplicable: 'هذا الحجز يُرسل تذكيره تلقائياً — تم تحديث الصف'
    },
    copy: {
      action: 'نسخ نص التذكير',
      copied: 'تم النسخ',
      failed: 'تعذّر النسخ'
    },
    // Checkout RECORD (tasks/manual-guest-checkout-event.md) — «هل غادر الضيف فعلاً؟»، وهو سؤال
    // مختلف تماماً عن سؤال التذكير أعلاه.
    //
    // ⚠️ المفردات مقفلة (D16): «أكد الفريق خروج الضيف» — وليس «الخروج الفعلي». الضغط على الزر
    // تأكيد بشري، لا رصد. عندما يصل جهاز (لوحة مفاتيح / NFC) يصبح الرصد ممكناً، وعندها فقط تتغير
    // الصياغة. ⚠️ «غادر الساعة» تشير إلى وقت مغادرة الضيف، لا وقت تسجيل الملاحظة.
    //
    // نفس الصياغة مكرّرة عمداً — لا مستوردة — في صفحة الحجز (BookingDetails.js)، لأن تلك الصفحة
    // عربية فقط ولا تمرّ على ملفات الترجمة. أي تعديل هنا يُطبَّق هناك أيضاً.
    checkout: {
      action: 'تأكيد الخروج',
      // بديل هادئ لصفٍّ أبلغ فيه الضيف بنفسه: لا مطلوب من الفريق شيء، والزر خيار للتصحيح لا مهمة.
      // نفس التمييز الذي تستخدمه صفحة الحجز بالفعل.
      opsOverride: 'تأكيد الفريق',
      // ⚠️ مفردات خاصة بهذا العمود، لا تُستعار من `status.*` أعلاه (D19). عمود التذكير يقول «جاهز»
      // لأن النظام أرسل الرسالة ويستطيع إثبات ذلك؛ أما هنا فإنسان أكّد واقعة لم يرصدها جهاز.
      // استخدام نفس الكلمة ونفس اللون الأخضر كان يجعل مكالمة هاتفية تبدو بقوة دليل القفل.
      state: {
        recorded: 'سُجّل',
        // الضيف ضغط الزر على لوحة الباب بنفسه — خبر منه، وليس تأكيداً من الفريق (D19).
        recordedByGuest: 'أبلغ الضيف',
        notRecorded: 'لم يُسجَّل'
      },
      // الحالة قبل التسجيل: رمادية، لا حمراء — هذا سجلّ لواقعة، وليس مهمة متأخرة على الفريق.
      notRecorded: 'لم يُسجَّل خروج الضيف بعد',
      left: 'غادر الساعة',
      by: 'سجّله',
      save: 'حفظ',
      cancel: 'إلغاء',
      undo: 'تراجع',
      timeLabel: 'وقت مغادرة الضيف',
      // «حسب توقيت الرياض» صراحةً: حقل datetime-local لا يحمل منطقة زمنية، ومن يعمل خارج السعودية
      // سيكتب ساعته هو دون أن يدري.
      timeHint: 'بتوقيت الرياض — عدّل الساعة إن كان الضيف قد غادر قبل الآن.',
      failed: 'تعذّر الحفظ — حاول مرة أخرى',
      notApplicable: 'الحجز ملغي — لا يوجد ضيف ليغادر',
      timeInvalid: 'وقت الخروج غير صالح — لا يمكن أن يكون في المستقبل أو قبل وصول الضيف'
    }
  },
  // ── إشعارات الدفع (لوحة الإعدادات) ────────────────────────────────────────────────────────────
  //
  // ⚠️ نُقلت من `web/src/config/notificationLabels.js` في 2026-08-04
  // (tasks/manual-guest-checkout-event.md D31/D32). كان ذلك الملف عربياً فقط بافتراض مكتوب صراحةً:
  // «هذه الشاشة لموظفي العمليات فقط، فلا يصلها مستخدم بالإنجليزية». نوع `guest_checkout` يكسر هذا
  // الافتراض — فريق النظافة يصل اللوحة الآن، وهو تحديداً من وُجدت الإنجليزية لأجله.
  notifications: {
    loading: 'جاري تحميل إعدادات الإشعارات...',
    browserPermission: 'إذن المتصفح',
    enable: 'تفعيل الإشعارات',
    reEnable: 'إعادة التفعيل',
    enabling: 'جاري التفعيل...',
    testSend: 'أرسل لي إشعارًا تجريبيًا',
    testing: 'جاري الإرسال...',
    enabledNotice: '✅ تم تفعيل الإشعارات على هذا الجهاز',
    removedNotice: 'تمت إزالة الجهاز',
    remove: 'إزالة',

    typesTitle: 'أنواع الإشعارات',
    typesHint: 'تنطبق هذه الخيارات على جميع أجهزتك، وتخصّك وحدك.',
    devicesTitle: 'أجهزتي',
    devicesHint: 'كل متصفح على كل جهاز يُسجَّل مرة واحدة. أزل أي جهاز لم تعد تستخدمه.',
    devicesEmpty: 'لم تُفعّل الإشعارات على أي جهاز بعد',
    thisDevice: 'هذا الجهاز',
    lastAccepted: 'آخر تأكيد',
    neverReceived: 'لم يُستلم أي إشعار بعد',
    // القاعدة: يُعلَّم الجهاز بعدد مرات الفشل المتتالية، لا بمرور الوقت — هاتف لم يصله إشعار في
    // أسبوع هادئ ليس معطلاً.
    failing: 'فشل الإرسال مؤخراً',

    // حالة كل جهاز — «يحتاج إعادة تفعيل» هو الوجه الظاهر لحماية مفتاح VAPID: جهاز سُجّل بمفتاح آخر
    // لا يمكنه استقبال أي شيء، وقول ذلك يحوّل «هاتفي صامت بلا سبب» إلى تعليمة قابلة للتنفيذ.
    health: {
      ok: 'يعمل',
      stale: 'يحتاج إعادة تفعيل',
      unknown: 'غير مؤكد'
    },

    // إذن المتصفح كما هو، دون تفسير. «محظور» لا يحصل على زر إعادة محاولة في أي مكان: الطلب مجدداً
    // يُحسم فوراً دون أي نافذة، فالصادق الوحيد هو الإشارة إلى مكان المفتاح الحقيقي.
    permission: {
      granted: 'مسموح',
      denied: 'محظور',
      default: 'لم يُطلب بعد',
      unsupported: 'غير مدعوم في هذا المتصفح'
    },

    // بطاقة الحالة: في أي وضع نحن، وما الإجراء الوحيد التالي.
    status: {
      unreadableTitle: 'تعذّر قراءة حالة الإشعارات',
      unreadableDetail: 'لم نتمكن من الوصول إلى الخادم. حدّث الصفحة، وإذا استمر ذلك أبلغ الدعم.',
      disabledTitle: 'الإشعارات غير مفعّلة',
      disabledDetail: 'خاصية الإشعارات غير مفعّلة في هذه البيئة. لا حاجة لأي إجراء منك.',
      unconfiguredTitle: 'الإشعارات غير مهيأة على الخادم',
      unconfiguredDetail: 'تواصل مع الدعم الفني — لا يمكن تفعيل الإشعارات حتى تُضبط على الخادم.',
      iosInstallTitle: 'أضف هوست مي إلى الشاشة الرئيسية أولاً',
      iosInstallDetail: 'على الآيفون والآيباد، لا تصل الإشعارات إلا بعد إضافة الموقع إلى الشاشة الرئيسية. الخطوات بالأسفل.',
      unsupportedTitle: 'هذا المتصفح لا يدعم الإشعارات',
      unsupportedDetail: 'جرّب Chrome أو Edge أو Safari على جهاز آخر، أو استخدم الحاسب.',
      deniedTitle: 'الإشعارات محظورة في هذا المتصفح',
      deniedDetail: 'اسمح بالإشعارات لهذا الموقع من إعدادات المتصفح (رمز القفل بجوار العنوان)، ثم أعد تحميل الصفحة.',
      onTitle: 'الإشعارات مفعّلة على هذا الجهاز',
      onDetail: 'ستصلك تنبيهات حسب الأنواع المفعّلة بالأسفل. جرّبها الآن للتأكد.',
      staleTitle: 'يحتاج هذا الجهاز إعادة تفعيل',
      staleDetail: 'تم تسجيل هذا الجهاز بإعدادات قديمة ولن تصله الإشعارات. اضغط «إعادة التفعيل».',
      unknownTitle: 'حالة هذا الجهاز غير مؤكدة',
      unknownDetail: 'لا يمكننا تأكيد أن الإشعارات ستصل إلى هذا الجهاز. اضغط «إعادة التفعيل» للتأكد.',
      offTitle: 'الإشعارات غير مفعّلة على هذا الجهاز',
      offDetail: 'فعّلها لتصلك تنبيهات فورية دون فتح النظام.'
    },

    // خطوات الآيفون: Safari لا يتيح الإشعارات إلا لصفحة مضافة للشاشة الرئيسية، ولا يمكن لأي كود
    // أن يطلب ذلك — خطوة يدوية لكل جهاز، فمهمة اللوحة أن تجعلها واضحة لا أن تعتذر عنها.
    iosTitle: '📲 خطوات الإضافة إلى الشاشة الرئيسية',
    iosSteps: [
      'افتح هذا الموقع في متصفح Safari',
      'اضغط زر المشاركة في أسفل الشاشة',
      'اختر «إضافة إلى الشاشة الرئيسية»',
      'افتح هوست مي من الأيقونة الجديدة، ثم فعّل الإشعارات من هذه الصفحة'
    ],

    // ⚠️ المفاتيح هنا هي مفاتيح سجل الأنواع في الخادم (be/services/notifications/types.js)
    // وهي محفوظة وتعاقدية: تغيير اسم مفتاح هنا يُنتج مفتاحاً بلا عنوان، لا خطأ في البناء.
    types: {
      guest_message: {
        label: 'رسائل الضيوف',
        description: 'تنبيه عند وصول رسالة جديدة من ضيف'
      },
      lock_incident: {
        label: 'حوادث الأقفال العاجلة',
        description: 'تنبيه في حالة قفل عاجل يؤثر على دخول ضيف (محاولات دخول فاشلة، رمز معطّل)'
      },
      // ⚠️ مفتاح منفصل عن lock_incident عن قصد: من يكتم تنبيهات البطارية يجب ألّا يكتم معها
      // «الضيف واقف أمام باب لا يفتح». صيانة مجدولة وحالة طارئة لا يجمعهما مفتاح واحد.
      lock_battery: {
        label: 'بطارية القفل',
        description: 'تنبيه عند انخفاض بطارية قفل إلى مستوى حرج يستدعي استبدالها فوراً'
      },
      // 🔴 يُخبر ولا يأمر (D23): «غادر الضيف»، وليس «ابدأ التنظيف».
      guest_checkout: {
        label: 'مغادرة الضيف',
        description: 'تنبيه عند تسجيل مغادرة ضيف من وحدة لديك مهمة تنظيف فيها'
      },
      // تنبيه واحد فقط قبل ١٠ دقائق من الوقت المستهدف — لا شيء بعد تجاوزه (tasks/cleaning-timer.md D11).
      clean_target: {
        label: 'الوقت المستهدف للتنظيف',
        description: 'تنبيه واحد قبل ١٠ دقائق من انتهاء الوقت المستهدف للتنظيف الذي بدأته'
      },
      // One person only, set in the server's config (tasks/cleaning-manager-arrival-alert.md).
      cleaning_arrival: {
        label: 'النظافة غير جاهزة قبل وصول الضيف',
        description: 'تنبيه عندما يقترب وصول الضيف ولم تبدأ النظافة أو لم تكتمل — يُرسل فقط للشخص المحدد لاستلامه'
      },
      // حجزان لنفس الوحدة في نفس الليالي — يُرسل مرة واحدة لكل تعارض جديد (tasks/booking-conflict-push.md).
      booking_conflict: {
        label: 'تعارضات الحجز',
        description: 'تنبيه عند اكتشاف حجزين متداخلين على نفس الوحدة في نفس الليالي'
      },
      // تغيير من المنصة رفضه النظام — يُرسل مرة واحدة لكل حجز (tasks/booking-desync-alarm.md).
      booking_desync: {
        label: 'تعديلات المنصات غير المطبّقة',
        description: 'تنبيه عندما يصل حجز أو تعديل أو إلغاء من Airbnb أو Booking.com ولا يستطيع النظام تطبيقه'
      },
      owner_new_booking: {
        label: 'الحجوزات الجديدة',
        description: 'تنبيه عند وصول حجز جديد لوحدتك من منصات الحجز'
      },
      owner_booking_cancelled: {
        label: 'إلغاء الحجوزات',
        description: 'تنبيه عند إلغاء حجز في وحدتك من منصات الحجز'
      },
      unknown: {
        label: 'إشعار',
        description: 'نوع إشعار غير معروف في هذه النسخة'
      }
    },

    // «تم الإرسال إلى N من أجهزتك» — العربية تميّز المفرد والمثنى والجمع، وهذا ليس اختيارياً هنا:
    // الخادم لا يُبلغ بالنجاح إلا إذا قبِل جهاز واحد على الأقل، فكانت «إلى ١ من أجهزتك» أكثر الصيغ
    // ظهوراً وهي مكسورة لأذن عربية. المثنى «جهازيك» لا مقابل له في الإنجليزية.
    testSent: {
      one: '✅ تم إرسال إشعار تجريبي إلى جهازك — تحقق من شاشة الجهاز الآن',
      two: '✅ تم إرسال إشعار تجريبي إلى جهازيك — تحقق من شاشتي الجهازين الآن',
      many: '✅ تم إرسال إشعار تجريبي إلى {count} من أجهزتك — تحقق من شاشات أجهزتك الآن'
    },

    // أكواد أخطاء الخادم ← ما ينبغي أن يقرأه المستخدم. كل واحدة مكتوبة كحالة + ما العمل.
    // «فشل» وحدها تخبر أن شيئاً ما تعطّل ولا تقول لمن المشكلة.
    errors: {
      API_004: 'تم إرسال عدة إشعارات تجريبية. انتظر دقيقة ثم حاول مرة أخرى',
      PUSH_DISABLED: 'الإشعارات غير مفعّلة في هذه البيئة',
      PUSH_NOT_CONFIGURED: 'الإشعارات غير مهيأة على الخادم — تواصل مع الدعم الفني',
      PUSH_INVALID_SUBSCRIPTION: 'تعذّر تسجيل هذا المتصفح. جرّب إعادة تحميل الصفحة ثم المحاولة مرة أخرى',
      PUSH_DEVICE_NOT_FOUND: 'الجهاز غير موجود — ربما تمت إزالته من جهاز آخر',
      PUSH_UNKNOWN_TYPE: 'نوع الإشعار غير معروف — حدّث الصفحة، فقد تكون نسخة النظام لديك قديمة',
      PUSH_NO_DEVICES: 'لم تُفعّل الإشعارات على أي جهاز بعد. فعّلها على هذا الجهاز أولاً',
      PUSH_SEND_FAILED: 'تعذّر إرسال الإشعار — المشكلة في خدمة الإشعارات وليست منك. حاول بعد قليل',
      generic: 'حدث خطأ غير متوقع. حاول مرة أخرى'
    },

    // أسباب فشل الاشتراك من جهة المتصفح — هذه هي الأسباب الآلية التي يُرجعها utils/serviceWorker.js،
    // وهو لا يعرض شيئاً بنفسه عن قصد.
    subscribeFailure: {
      unsupported: 'هذا المتصفح لا يدعم الإشعارات',
      not_configured: 'الإشعارات غير مهيأة على الخادم — تواصل مع الدعم الفني',
      denied: 'الإشعارات محظورة في إعدادات المتصفح لهذا الموقع. اسمح بها من إعدادات الموقع ثم أعد المحاولة',
      dismissed: 'لم يتم منح الإذن. اضغط «تفعيل الإشعارات» ثم اختر السماح',
      subscribe_failed: 'تعذّر تفعيل الإشعارات على هذا الجهاز. أعد تحميل الصفحة وحاول مرة أخرى'
    }
  },
  locks: {
    tabLabel: 'الأقفال الذكية',
    // رابط لوحة تسجيل الخروج — tasks/checkout-plaque-panel.md. Lives in the locks tab because it is
    // the same physical object to whoever is standing at the door.
    plaque: {
      heading: 'رابط لوحة تسجيل الخروج',
      copy: 'نسخ الرابط',
      copied: 'تم النسخ',
      // تصدير رمز QR — tasks/checkout-plaque-artwork-generator.md. اسم الملف هو رمز الوحدة، وهو ما
      // يربط الملف بشقته عند المصمم، فلا توجد قائمة منفصلة يجب أن تبقى متطابقة.
      download: 'تنزيل رمز QR',
      downloadNote: 'ملف متجّه باسم الوحدة، جاهز ليضعه المصمم في تصميم اللوحة. للتحقّق بعد الطباعة: امسح الرمز — الصفحة تذكر اسم الشقة.',
      downloadNoCode: 'لا يمكن تنزيل الرمز لأن هذه الوحدة بلا رمز تعريفي — اسم الملف هو ما يربطه بشقته.',
      downloadFailed: 'تعذّر تجهيز ملف الرمز. أعد المحاولة.',
      loading: 'جارٍ الجلب…',
      note: 'هذا الرابط دائم ويخص هذه الوحدة وحدها. بعد تركيب اللوحة على الباب، تغييره يستلزم زيارة الوحدة — تأكّد من الوحدة قبل الطباعة أو البرمجة.',
      noToken: 'لم يُنشأ رابط لهذه الوحدة بعد — الوحدات المضافة قبل هذه الميزة تحتاج تشغيل سكربت التعبئة أولاً.',
      failed: 'تعذّر جلب رابط لوحة تسجيل الخروج.'
    },
    panel: {
      heading: 'حالة القفل',
      noLockMapped: 'لا يوجد قفل مرتبط بهذا العقار',
      mapButton: 'ربط قفل بهذا العقار',
      unmapButton: 'إلغاء الربط',
      unmapping: 'جاري إلغاء الربط...',
      unmapConfirm: {
        message: 'هل أنت متأكد من إلغاء ربط هذا القفل؟ سيتم إيقاف المزامنة، مع الاحتفاظ بسجل الأحداث للمراجعة.',
        confirm: 'تأكيد الإلغاء',
        cancel: 'تراجع'
      },
      unmapError: 'تعذر إلغاء ربط القفل',
      loading: 'جاري التحميل...',
      battery: {
        label: 'البطارية',
        lastReported: 'آخر قراءة',
        unknown: 'غير معروف'
      },
      // Remote-manageability, NOT general health: an "unavailable" lock still opens
      // for guests on the keypad — it just cannot receive new/changed codes from us.
      // The old متصل/غير متصل wording read as "this lock is broken" and made a working
      // fleet look failed (prod 2026-07-28).
      online: 'متاح للأوامر عن بُعد',
      offline: 'غير متاح للأوامر عن بُعد',
      lastSync: {
        passcodes: 'آخر مزامنة للرموز',
        events: 'آخر مزامنة للأحداث',
        never: 'لم تتم بعد'
      },
      codes: {
        heading: 'الرموز المخزنة',
        emptyState: 'لا توجد رموز مخزنة',
        matchedGuest: 'ضيف مطابق',
        staffOrUnknown: 'موظف / غير محدد',
        nonConforming: 'تنسيق غير مطابق',
        permanent: 'دائم',
        expired: 'منتهي',
        syncing: 'قيد المزامنة',
        notYetActive: 'لم يبدأ بعد',
        validUntil: 'ساري حتى',
        validFrom: 'يبدأ في'
      },
      suggestedCode: {
        heading: 'الرمز المقترح للضيف الحالي',
        displayOnlyBadge: 'للعرض في المنصة فقط — لم يتم إرساله من قبل المنصة للضيف',
        none: 'لا يوجد رمز مقترح',
        ambiguous: 'غير محدد — رموز متعددة محتملة',
        tooltip: 'اختير الرمز لأن اسمه يطابق حجزاً نشطاً اليوم. لا يُكتب في أي مكان — للعرض فقط.'
      },
      events: {
        heading: 'السجلات الأخيرة (آخر ٢٠ سجل)',
        emptyState: 'لا توجد أحداث',
        recordType: {
          passcode: 'رمز',
          fingerprint: 'بصمة',
          bluetooth: 'بلوتوث / تطبيق',
          icCard: 'بطاقة',
          remoteApp: 'فتح عن بُعد',
          unknown: 'نوع غير معروف'
        },
        success: 'ناجح',
        failed: 'فشل'
      },
      error: {
        title: 'تعذر تحميل بيانات القفل',
        retry: 'إعادة المحاولة'
      }
    },
    mappingModal: {
      title: 'ربط قفل ذكي',
      instruction: 'اختر قفلاً لربطه بهذا العقار:',
      searchPlaceholder: 'ابحث بالاسم أو الرقم أو العنوان...',
      noSearchMatches: 'لا توجد أقفال تطابق البحث',
      loading: 'جاري تحميل الأقفال غير المرتبطة...',
      empty: 'لا توجد أقفال متاحة للربط',
      lockId: 'الرقم التعريفي',
      battery: 'البطارية',
      online: 'متاح للأوامر عن بُعد',
      offline: 'غير متاح للأوامر عن بُعد',
      cancel: 'إلغاء',
      submit: 'ربط',
      submitting: 'جاري الربط...',
      successTitle: 'تم ربط القفل بنجاح',
      error: {
        title: 'تعذر إتمام عملية الربط',
        loadFailed: 'تعذر تحميل قائمة الأقفال',
        selectRequired: 'يرجى اختيار قفل أولاً'
      }
    },
    table: {
      heading: 'الأقفال الذكية',
      subtitle: 'نظرة عامة على حالة الأقفال عبر العقارات',
      noLocks: 'لا توجد أقفال مرتبطة',
      attentionFilter: 'تتطلب انتباهاً فقط',
      attentionBadge: 'يحتاج انتباه',
      column: {
        lock: 'القفل',
        property: 'العقار',
        battery: 'البطارية',
        online: 'الحالة',
        lastSync: 'آخر مزامنة',
        alerts: 'التنبيهات'
      },
      reasons: {
        low_battery: 'بطارية منخفضة',
        no_active_code: 'لا يوجد رمز فعال',
        unreachable: 'غير متاح للأوامر عن بُعد'
      },
      error: {
        title: 'تعذر تحميل قائمة الأقفال',
        retry: 'إعادة المحاولة'
      }
    }
  },

  // ── Pricing guidance (ops-only) ────────────────────────────────────────────
  // This surface GUIDES; it never suggests a price and never writes one. Nothing
  // in here may imply the system recommends a figure — that claim has not been
  // earned and a suggestion ops learns to distrust is worse than none.
  pricing: {
    page: {
      title: 'مساعد التسعير',
      subtitle: 'ما تحققه الوحدة فعلياً، وما تُسعّر به إقامة قادمة',
      opsBadge: 'أداة داخلية — للفريق التشغيلي فقط',
      readOnly: 'هذه الصفحة للاطلاع فقط — تغيير السعر المعلن يتم من تقويم العقار',
      selectUnit: 'اختر الوحدة',
      noUnits: 'لا توجد وحدات متاحة',
      loading: 'جاري التحميل...',
      loadError: 'تعذر تحميل بيانات التسعير',
      retry: 'إعادة المحاولة'
    },
    common: {
      currency: 'ر.س',
      perNight: 'ليلة',
      nights: 'ليلة',
      of: 'من',
      unknown: 'غير معروف',
      none: '—',
      listSeparator: '، ',
      // The footing beside every figure. Small and secondary — but present, because its
      // absence is exactly how someone "fixes" a number by multiplying it by 1.15 later.
      exVat: 'قبل الضريبة',
      incVat: 'شامل الضريبة'
    },
    // Backend failures are identified by `code`, never by the Arabic string beside it —
    // see utils/pricingErrorCodes.js.
    errors: {
      unitNotFound: 'الوحدة غير موجودة',
      invalidUnit: 'معرّف الوحدة غير صالح',
      invalidDates: 'تواريخ غير صالحة — تحقق من تاريخ الوصول والمغادرة ومن ألا تتجاوز المدة سنة',
      invalidPolicy: 'الإعدادات غير صالحة — تحقق من الحد الأدنى وسعر التقويم الافتراضي ومن خصومات الإقامة الطويلة',
      invalidDiscount: 'نسبة الخصم غير صالحة — يجب أن تكون بين 0 و100',
      forbidden: 'ليس لديك صلاحية للوصول إلى هذه البيانات',
      system: 'خطأ في النظام — يرجى المحاولة مرة أخرى'
    },
    scoreboard: {
      achievedRate: 'متوسط السعر المحقق من الحجوزات',
      achievedRateWindow: 'آخر 90 يوماً',
      basedOn: 'محسوب على',
      occupancy: 'الإشغال المتوقع',
      occupancyWindow: 'الـ30 يوماً القادمة',
      occupancySold: 'مباعة',
      occupancySellable: 'ليلة قابلة للبيع',
      typicalPrice: 'السعر المعروض في التقويم',
      typicalPriceWindow: 'وسيط الـ30 يوماً القادمة',
      unsold: 'ليالٍ غير مباعة',
      unsoldWindow: 'ضمن الـ30 يوماً القادمة',
      nothingSellable: 'غير متاحة للبيع',
      nothingSellableHint: 'الوحدة محجوزة تشغيلياً بالكامل — هذا ليس ضعفاً في الطلب',
      heldNights: 'ليلة محجوزة تشغيلياً',
      noData: 'لا توجد بيانات',
      caveatPrefix: 'السعر المحقق محسوب على',
      caveatMiddle: 'ليلة فقط من أصل',
      caveatSuffix: 'ليلة مشغولة — بيانات إحدى الإقامات لم تُدخل بعد، فكل سعر هنا يستند إلى عينة أصغر من نسبة الإشغال',
      byChannel: 'حسب المنصة',
      byChannelHint: 'السعر المحقق لكل منصة — للتشخيص فقط. لا يُستخدم في الحد الأدنى ولا في التسعير.'
    },
    weekday: {
      heading: 'الأداء حسب أيام الأسبوع',
      hint: 'آخر 90 يوماً. «الإشغال» يعني كم مرة امتلأت هذه الليلة — وليس حجم الطلب المستقل عليها، لأن إقامة تمتد من نهاية الأسبوع تُحسب أيضاً لأيام الأسبوع التي تغطيها.',
      day: 'اليوم',
      achievedRate: 'السعر المحقق',
      occupancy: 'الإشغال',
      effectiveRevenue: 'العائد الفعلي',
      effectiveRevenueHint: 'الإيراد المحقق لكل ليلة متاحة — أدنى رقم هو أضعف يوم. محسوب من الليالي المسعّرة فقط، فلا يساوي بالضرورة حاصل ضرب العمودين المجاورين.',
      sample: 'العينة',
      quietest: 'أضعف يوم',
      noSample: 'لا توجد عينة',
      noRateSample: 'لم تُدخل مبالغ',
      empty: 'لا توجد بيانات لأيام الأسبوع في هذه الفترة'
    },
    days: {
      heading: 'الأسعار المعلنة — 30 يوماً',
      hint: 'اضغط على أي يوم لفتح تقويم العقار على ذلك التاريخ',
      date: 'التاريخ',
      published: 'السعر المعلن',
      state: 'الحالة',
      sold: 'مباعة',
      stopSell: 'موقوفة عن البيع',
      held: 'محجوزة تشغيلياً',
      available: 'متاحة',
      noRate: 'بدون سعر',
      noLedgerRow: 'التقويم لا يمتد إلى هذا التاريخ',
      empty: 'لا توجد أيام لعرضها'
    },
    quote: {
      heading: 'تسعير إقامة',
      // Was "the total is the sum of the published rates" — untrue the moment a unit has a
      // commercial reference, which is the basis now. Says what the block IS instead.
      hint: 'حاسبة فقط — لا تُحفظ ولا تُنشئ حجزاً',
      checkIn: 'تاريخ الوصول',
      checkOut: 'تاريخ المغادرة',
      // The result outlives edits to the form until the next submit. Without this the
      // table reads as current — ops typed a percent, never pressed the button, and read
      // a figure back off a previous calculation with nothing on screen saying so.
      stale: 'التواريخ تغيّرت — اضغط «احسب السعر»',
      submit: 'احسب السعر',
      submitting: 'جاري الحساب...',
      nights: 'عدد الليالي',
      // The stay strip above the table. `basisTotal` is what the discount comes OFF —
      // the unit's reference × nights, or the summed published nights when it has none.
      basisTotal: 'المجموع قبل الخصم',
      tier: 'خصم الإقامة الطويلة',
      tierFrom: 'من',
      vat: 'الضريبة',
      incomplete: 'لا يمكن تسعير هذه الإقامة',
      // These three are completed by a "{n} ليلة" prefix in the component — they must
      // NOT repeat the noun, or the line reads "1 ليلة ليلة موقوفة عن البيع".
      incompleteHint: 'بلا سعر معلن — أضف السعر في تقويم العقار أولاً',
      forDates: 'للفترة',
      soldWarning: 'مباعة ضمن هذه الفترة — لا يمكن قبول الحجز كما هو',
      heldWarning: 'محجوزة تشغيلياً لضيف مُعاد إسكانه — الوحدة مشغولة فعلياً ولا يمكن بيعها',
      stopSoldWarning: 'موقوفة عن البيع ضمن هذه الفترة',
      belowFloor: 'أقل من الحد الأدنى المحدد للوحدة',
      publishedNow: 'المعروض الحالي في التقويم',
      advisory: 'تنبيه إرشادي فقط — لا يمنع التسعير',
      error: 'تعذر حساب السعر',
      invalidDates: 'تاريخ المغادرة يجب أن يكون بعد تاريخ الوصول'
    },
    economics: {
      direct: 'حجز مباشر',
      airbnb: 'Airbnb',
      booking: 'Booking.com',
      guestPays: 'يدفع الضيف',
      roomRevenue: 'الإيراد',
      otaFee: 'رسوم المنصة',
      commissionBase: 'أساس احتساب الرسوم',
      hostMeCommission: 'عمولة هوست مي',
      ownerNet: 'صافي المالك'
    },
    // The direct-price what-if. An INPUT, never a suggestion — how much of the platform
    // saving to pass to the guest is a commercial call per booking.
    direct: {
      channelLabel: 'العرض على',
      total: 'المجموع للضيف',
      perNight: 'لليلة',
      // ONE lever, pre-filled with the unit's own tier and always measured off the base.
      // Two boxes measuring from two different starting points is what let a 15% tier and
      // a 10% offer compound to 23.5% with no figure on screen saying so.
      discountPercent: 'الخصم ٪',
      // Names where the percent in the box came from, so a deviation is visible as one.
      unitDiscount: 'خصم الوحدة',
      vatOn: 'احتساب الضريبة',
      // Guards the tick against being read as a 30-night rule: ZATCA sets no
      // night-count threshold, and serviced accommodation stays standard-rated.
      vatCaution: 'إلغاء الضريبة قرار محاسبي خاص بالوحدة — تجاوز الإقامة 30 ليلة لا يعفيها وحده',
      vatWhatIf: 'حسب الاختيار أعلاه',
      noVat: 'بدون ضريبة',
      flatRateNote: 'السعر المُدخل يُطبَّق كسعر ثابت لكل الليالي — وهذا يلغي اختلاف الأسعار بين ليالي نهاية الأسبوع وبقية الأيام.',
      guestPaysNow: 'الضيف يدفع',
      directVia: 'بالحجز المباشر عبر منصة هوست مي',
      insteadOf: 'بدلاً من',
      viaPlatform: 'عبر المنصات الأخرى',
      onChannel: 'على',
      guestSaves: 'يوفّر'
    },
    policy: {
      heading: 'إعدادات الوحدة',
      hint: 'جميع القيم قبل الضريبة، مثل السعر المعلن في التقويم.',
      referenceRate: 'السعر الأساسي',
      referenceRateHint: 'السعر المعتاد للوحدة — منه يُحسب سعر العرض',
      floor: 'الحد الأدنى لليلة',
      floorHint: 'إرشادي فقط — يظهر كتنبيه عند النزول تحته ولا يمنع العرض',
      calendarHeading: 'تقويم الليالي الجديدة',
      calendarHint: 'يُمدَّد تقويم الوحدة تلقائياً كل ليلة ليبقى متاحاً للحجز 500 يوم قادمة. الليالي الجديدة فقط تُسعَّر بهذا السعر — لا يتغير سعر أي ليلة موجودة.',
      calendarRate: 'سعر التقويم الافتراضي',
      calendarRateHint: 'سعر الليلة الجديدة المعروض على المنصات — مطلوب، وبدونه لا يُمدَّد التقويم',
      calendarWeekendUplift: 'زيادة نهاية الأسبوع ٪',
      calendarWeekendUpliftHint: 'تُضاف على ليالي الجمعة والسبت الجديدة',
      calendarRateMissing: 'لم يُحدَّد سعر التقويم الافتراضي — تقويم هذه الوحدة لن يُمدَّد',
      tiers: 'خصومات الإقامة الطويلة',
      tiersHint: 'الخصم يبدأ من ليلتين فأكثر — خصم 3 أو 4 ليالٍ هو ما يملأ منتصف الأسبوع',
      minNights: 'من (ليالٍ)',
      discountPercent: 'الخصم ٪',
      addTier: 'إضافة خصم',
      removeTier: 'حذف',
      noTiers: 'لا توجد خصومات محددة',
      save: 'حفظ',
      saving: 'جاري الحفظ...',
      saved: 'تم الحفظ',
      saveError: 'تعذر حفظ الإعدادات',
      tierIncomplete: 'أكمل عدد الليالي ونسبة الخصم في كل صف، أو احذف الصف',
      invalidNumber: 'قيمة رقمية غير صالحة'
    },
    // «الخصومات والعروض الحالية» — what the unit's Airbnb listing is running, read from Channex.
    // tasks/pricing-listing-build-brainstorm.md (Phase 1, slice 1a). Figures and "%" are added in code.
    offers: {
      heading: 'الخصومات والعروض الحالية على Airbnb',
      airbnbOnly: 'لا تشمل Booking.com وGathern',
      account: 'الحساب',
      lastRead: 'آخر قراءة',
      unpublished: 'الإعلان غير منشور على Airbnb',
      refresh: 'تحديث',
      refreshing: 'جاري التحديث...',
      loading: 'جاري تحميل خصومات Airbnb...',
      loadError: 'تعذر تحميل خصومات Airbnb',
      // The account's Channex Rate Logic (the VAT-parity rule).
      // No brackets around the Latin word: in an Arabic line «(من Channex)» renders as «(Channex (من».
      accountRule: 'على كل أسعار هذا الحساب في Airbnb، من إعدادات Channex',
      accountRuleUnknownValue: 'زيادة على أسعار هذا الحساب — لم تُقرأ النسبة',
      noAccountRule: 'لا توجد زيادة على أسعار هذا الحساب في Channex',
      otherAccountRule: 'إعداد آخر على أسعار هذا الحساب في Channex:',
      unknownRuleFormat: 'صيغة غير معروفة:',
      promotionsLabel: 'العروض المفعّلة',
      noPromotions: 'لا توجد عروض مفعّلة',
      promotion: {
        NEW_LISTING_PROMOTION: 'عرض الإعلان الجديد',
        HIGH_RATED_GUEST_DISCOUNT: 'خصم الضيوف ذوي التقييم العالي',
        MOBILE_ONLY_DISCOUNT: 'خصم الحجز من تطبيق الجوال'
      },
      discountsLabel: 'الخصومات',
      discountColumn: 'الخصم',
      valueColumn: 'النسبة',
      noDiscounts: 'لا توجد خصومات على هذا الإعلان',
      weekly: 'خصم الأسبوع',
      monthly: 'خصم الشهر',
      stayAtLeast: 'خصم الإقامة',
      lastMinute: 'خصم اللحظة الأخيرة',
      earlyBird: 'خصم الحجز المبكر',
      // Worded with a colon so the count never follows a preposition («بـ يومان» is wrong Arabic).
      bookedBefore: 'المدة بين الحجز والوصول:',
      orMore: 'أو أكثر',
      orLess: 'أو أقل',
      // Arabic number agreement: 1 · 2 (dual, shown without the figure) · 3–10 · 11+.
      nightForms: { one: 'ليلة', two: 'ليلتان', few: 'ليالٍ', many: 'ليلة' },
      dayForms: { one: 'يوم', two: 'يومان', few: 'أيام', many: 'يوماً' },
      overrideTitle: 'العرض المفعّل يلغي خصومات هذه الوحدة',
      overrideBody: 'يطبّق Airbnb العرض وحده، فالخصومات أدناه لا تصل للضيف ما دام العرض مفعّلاً.',
      changed: 'تغيّر',
      changeNoticed: 'لوحظ تغيير في',
      changeAfter: 'بعد قراءة',
      changePublished: 'تغيّرت حالة نشر الإعلان',
      changeRemoved: 'أُزيل',
      staleTitle: 'آخر قراءة ناجحة كانت قبل أكثر من يومين',
      staleBody: 'قد لا يطابق المعروض Airbnb الآن. اضغط «تحديث».',
      noListing: 'لا يوجد رقم إعلان Airbnb مسجّل لهذه الوحدة، فلا يمكن عرض خصوماتها.',
      notReadYet: 'لم تُقرأ هذه الوحدة من Channex بعد. اضغط «تحديث».',
      notOnAccount: 'إعلان هذه الوحدة لم يعد ضمن حساب Airbnb هذا في Channex. تحقق من ربط الإعلان.',
      refreshCooldown: 'قُرئ هذا الحساب قبل أقل من دقيقة. أعد المحاولة بعد قليل.',
      refreshFailed: 'تعذّرت القراءة من Channex. المعروض هو آخر نسخة محفوظة.',
      refreshTimeout: 'القراءة من Channex تأخرت وستُحفظ عند اكتمالها. اضغط «تحديث» بعد دقيقة.',
      refreshUnavailable: 'القراءة من Channex غير متاحة في هذه البيئة.'
    }
  },
  // «دليل الضيف» — company-wide content tab + the unit guidebook additions.
  // tasks/guest-guide-sections-and-print-sheet.md
  guestGuide: {
    general: {
      tabTitle: 'دليل الضيف العام',
      intro: 'المحتوى الموحّد لكل الوحدات: يظهر في دليل الضيف وفي الورقة المطبوعة داخل الوحدة. يُكتب مرة واحدة هنا، ويمكن لأي وحدة استبدال قواعد الإقامة بقواعدها الخاصة من «دليل العقار».',
      notSavedYet: 'لم يُحفظ بعد — أرقام الطوارئ المعروضة مقترحة وتُحفظ مع أول حفظ.',
      lastSaved: 'آخر حفظ',
      arabic: 'عربي',
      english: 'English',
      houseRules: 'قواعد الإقامة',
      houseRulesHint: 'قاعدة واحدة في كل سطر — بحد أقصى 15 قاعدة.',
      quietHours: 'أوقات الهدوء',
      lostItems: 'المفقودات',
      wasteNote: 'ملاحظة عامة عن النفايات',
      wasteNoteHint: 'تظهر تحت مكان الحاوية الخاص بكل وحدة — مثل: فريق النظافة يتولى إخراج النفايات بعد المغادرة.',
      sustainability: 'الحفاظ على البيئة',
      customerServicePhone: 'رقم خدمة العملاء',
      socialHandle: 'حساب التواصل الاجتماعي',
      socialHandleHint: 'اسم الحساب نفسه على إنستغرام وتيك توك وسناب شات (بدون @). يظهر مع الشعارات أسفل الدليل والورقة المطبوعة.',
      emergencyNumbers: 'أرقام الطوارئ',
      labelAr: 'الجهة (عربي)',
      labelEn: 'الجهة (English)',
      number: 'الرقم',
      addNumber: 'إضافة رقم',
      remove: 'حذف',
      save: 'حفظ',
      saving: 'جاري الحفظ...',
      saved: 'تم الحفظ',
      loadError: 'تعذّر تحميل دليل الضيف العام',
      saveError: 'تعذّر حفظ دليل الضيف العام',
      incompleteNumber: 'أكمل الجهة (عربي) والرقم في كل صف من أرقام الطوارئ، أو احذف الصف.',
      readOnly: 'للاطلاع فقط — التعديل لمدير العمليات أو المسؤول.'
    },
    unit: {
      guestLink: 'رابط دليل الضيف',
      guestLinkHint: 'يُرسل تلقائياً مع رسالة تسجيل الدخول، وهو نفسه رمز QR في الورقة المطبوعة.',
      noLinkYet: 'يظهر الرابط بعد أول حفظ لدليل العقار — عدّل أي حقل أدناه.',
      copy: 'نسخ',
      copied: 'تم نسخ الرابط',
      copyFailed: 'تعذّر النسخ تلقائياً — انسخ الرابط يدوياً',
      preview: 'معاينة',
      print: 'طباعة',
      newLink: 'رابط جديد',
      newLinkTitle: 'إنشاء رابط جديد لدليل الضيف',
      newLinkBody: 'سيتوقف الرابط الحالي فوراً — بما في ذلك عند الضيوف الذين استلموه، ورمز QR المطبوع في الوحدة.',
      newLinkConfirm: 'أفهم أن رمز QR المطبوع في الوحدة سيتوقف، وسأعيد طباعة الورقة.',
      newLinkUse: 'استخدمه فقط إذا نُشر الرابط في مكان عام.',
      cancel: 'إلغاء',
      createNewLink: 'إنشاء رابط جديد',
      newLinkFailed: 'تعذّر إنشاء رابط جديد',
      waste: 'النفايات',
      wasteAr: 'مكان حاوية النفايات (عربي)',
      wasteEn: 'Waste / bins (English - اختياري)',
      unitRules: 'قواعد الإقامة الخاصة بالوحدة',
      unitRulesHint: 'اتركها فارغة لتستخدم الوحدة قواعد الشركة. عند الكتابة هنا تحلّ محل قواعد الشركة بالكامل في دليل الضيف والورقة المطبوعة — قاعدة في كل سطر، بحد أقصى 15.',
      unitRulesAr: 'القواعد (عربي)',
      unitRulesEn: 'Rules (English - اختياري)',
      companyRules: 'قواعد الشركة الحالية',
      companyRulesNone: 'لم تُكتب قواعد الشركة بعد — من «أتمتة الرسائل» ← «دليل الضيف العام».',
      usingCompanyRules: 'تستخدم هذه الوحدة قواعد الشركة.',
      usingUnitRules: 'تستخدم هذه الوحدة قواعدها الخاصة.',
      acAr: 'تعليمات المكيف (عربي)',
      heaterAr: 'تعليمات التدفئة (عربي)',
      guidebookLink: 'دليل العقار',
      rulesCount: 'عدد القواعد',
      rulesOverLimit: 'تجاوزت 15 قاعدة — لن يُحفظ إلا أول 15.',
      ruleTooLong: 'إحدى القواعد أطول من 300 حرف وستُقصّ.',
      acEn: 'AC instructions (English - اختياري)',
      heaterEn: 'Heater instructions (English - اختياري)',
      kitchenEn: 'Kitchen (English - اختياري)',
      washerEn: 'Washer / dryer (English - اختياري)',
      tvEn: 'TV (English - اختياري)'
    }
  },
  states: {
    loading: 'جاري التحميل...',
    retry: 'إعادة المحاولة'
  },
  ownerDashboard: {
    statsLoadError: 'تعذر تحميل إحصائيات وحداتك'
  },
  unitDetails: {
    bookingsLoadError: 'تعذر تحميل حجوزات الوحدة',
    calendarLoadError: 'تعذر تحميل التقويم — لا تعتمد على الأيام الظاهرة متاحة حتى يتم التحميل'
  },
  financePage: {
    noUnits: 'لا توجد وحدات مسجلة في حسابك بعد'
  },
  lists: {
    loadMoreFailed: 'تعذر تحميل المزيد — حاول مرة أخرى',
    filtersToggle: 'تصفية',
    loadMore: 'عرض المزيد',
    loadingMore: 'جاري التحميل...',
    showingOf: 'عرض {shown} من {total}'
  },
  bookingsList: {
    nightOne: 'ليلة واحدة',
    nightTwo: 'ليلتان',
    nightFew: 'ليالٍ',
    nightMany: 'ليلة',
    noBookings: 'لا توجد حجوزات بعد',
    noMatches: 'لا توجد حجوزات مطابقة للفلاتر المحددة',
    notSet: 'غير محدد'
  },
  guestsList: {
    noGuests: 'لا يوجد ضيوف بعد',
    noMatches: 'لا يوجد ضيوف مطابقون للبحث أو التصفية',
    unnamed: 'ضيف',
    bookings: 'حجز',
    lastBooking: 'آخر حجز'
  },
  opsPerformance: {
    title: 'مؤشر أداء العمليات',
    subtitle: 'متابعة شهرية لتقييم الضيوف والإشغال.',
    loadFailed: 'تعذّر تحميل المؤشرات الشهرية. حاول مرة أخرى.',
    info: 'معلومات',
    kpi: {
      rating: 'تقييم الضيوف',
      occupancy: 'الإشغال',
      soFar: '{month} حتى أمس',
      startsTomorrow: 'يبدأ العدّ غداً',
      reviews: '{count} {noun}',
      reviewNoun: { one: 'تقييم', two: 'تقييمان', few: 'تقييمات' },
      nightNoun: { one: 'ليلة', two: 'ليلتان', few: 'ليال' },
      noReviews: 'لا تقييمات',
      nights: '{booked} من {sellable} {noun}',
      closed: '{count} {noun} مغلقة',
      unrecorded: '{count} {noun} غير معروضة بلا سبب',
      unknown: '{count} {noun} بلا بيانات في التقويم',
      ratingNote: 'منذ البداية: {value} من {count} {noun}. Airbnb وBooking.com فقط.',
      occupancyNote: 'بعد استبعاد الليالي المغلقة.'
    },
    support: {
      title: 'مؤشرات مساندة',
      loading: 'جارٍ التحميل',
      failed: 'تعذّر جلب البيانات',
      lowSample: '(عينة قليلة)',
      replyLabel: 'الرد خلال ساعة',
      replyInfo: 'نسبة رسائل الضيوف التي تم الرد عليها خلال ساعة، خلال آخر ٧ أيام. تُحتسب الرسالة بعد الرد عليها أو بعد تجاوزها ساعة.',
      pending: 'قيد الانتظار: {count}',
      lowLabel: 'تقييمات أقل من 4.8',
      lowInfo: 'عدد التقييمات أقل من 4.8 نجوم التي وصلت خلال آخر ٧ أيام.',
      lastWeek: 'آخر 7 أيام',
      noCheckouts: 'لا مغادرات في الفترة',
      shareLabel: 'نسبة التقييمات',
      shareInfo: 'من النزلاء الذين غادروا بين {from} و{to} (Airbnb / Booking فقط)، كم تركوا تقييماً. تُقاس بعد ١٤ يوماً من المغادرة لأن التقييمات تصل متأخرة.',
      shareNote: '{reviewed} من {eligible} مغادرة'
    }
  }
};

export default ar;
